import { ValueType } from 'recharts/types/component/DefaultTooltipContent';

import { pulseChartColors } from '@/solaris-lens-common-lib/src/constants/colors';

export const AGGREGATE_LINE_KEY = 'genTotalAggregate';
export const AGGREGATE_LINE_LABEL = 'Gen Total';
export const AGGREGATE_LINE_COLOR = 'var(--main-blue-color)';
export const AGGREGATE_LINE_WIDTH = 2;
export const AGGREGATE_LINE_SHADOW_WIDTH = 5;
export const KW_TO_MW_DIVISOR = 1000;

interface ChartDataPoint {
  timestamp: string;
  [key: string]: string | number;
}

export const toGenTotalMwChartData = (dataPoints: ChartDataPoint[]) => {
  return dataPoints.map(row => ({
    timestamp: row.timestamp,
    [AGGREGATE_LINE_KEY]: Number(row[AGGREGATE_LINE_KEY]) / KW_TO_MW_DIVISOR
  }));
};

export const appendAggregateToChartData = (dataPoints: ChartDataPoint[]) => {
  return dataPoints.map(row => {
    const total = Object.entries(row)
      .filter(([key]) => key !== 'timestamp' && key !== AGGREGATE_LINE_KEY)
      .reduce((sum, [, value]) => sum + (Number(value) || 0), 0);

    return { ...row, [AGGREGATE_LINE_KEY]: total };
  });
};

export const generateColors = (count: number) => {
  return Array.from(
    { length: count },
    (_, index) => pulseChartColors[index % pulseChartColors.length]
  );
};

export const generateSingleColor = (index: number) => {
  return pulseChartColors[index % pulseChartColors.length];
};

export const formatXAxis = (timestamp: string) => {
  try {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;

    return `${month}/${day}\n${displayHours}:${minutes}:${seconds} ${ampm}`;
  } catch {
    return timestamp;
  }
};

export const formatTooltip = (value: ValueType, unit: string) => {
  if (value === undefined) return '';
  return `${value.toLocaleString()} ${unit}`;
};

export const formatTickDate = (timestamp: string) => {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}/${day}`;
};

export const formatTickTime = (timestamp: string) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${minutes} ${ampm}`;
};
